var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconcontactsphonework = function SvgIconcontactsphonework(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/contacts/icon.contacts.phone.work") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/contacts/icon.contacts.phone.work",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(17.500000, 12.500000) scale(-1, 1) translate(-17.500000, -12.500000) translate(12.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,21 L0,0.5 C-3.38176876e-17,0.223857625 0.223857625,5.07265313e-17 0.5,0 L10.5,0 C10.7761424,-5.07265313e-17 11,0.223857625 11,0.5 L11,6.5 L11,6.5",
    id: "Path-2",
    stroke: "#09BE86",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 2.000000)",
    fill: "#09BE86"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 3,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 4,
    y: 0,
    width: 3,
    height: 3,
    rx: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(1.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#09BE86",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 18,
    height: 14,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,15 L8,11.5 C8,11.2238576 8.22385763,11 8.5,11 L11.5,11 C11.7761424,11 12,11.2238576 12,11.5 L12,15 L12,15",
    id: "Path-6",
    fill: "#09BE86"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(3.000000, 3.000000)",
    fill: "#09BE86"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 0,
    y: 0,
    width: 3,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 5.5,
    y: 0,
    width: 3,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 11,
    y: 0,
    width: 3,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 0,
    y: 4,
    width: 3,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 5.5,
    y: 4,
    width: 3,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 11,
    y: 4,
    width: 3,
    height: 3,
    rx: 1
  }))))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconcontactsphonework);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.contacts.phone.work.5fc4830eece91c25320d1e52ba416395.svg";